<template>
  <div>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Add Product
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="product_type"
                outlined
                v-model="form.product_type_id"
                :items="productTypeItems"
                label="Property Type *"
                prepend-inner-icon="mdi-account-tie-outline"
                hide-details="auto"
                clearable
                :error-messages="errors.product_type_id"
              />
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="categories"
                outlined
                multiple
                v-model="form.category_ids"
                :items="categoryItems"
                label="Categories *"
                prepend-inner-icon="mdi-account-tie-outline"
                hide-details="auto"
                clearable
                :error-messages="errors.category_ids"
              />
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.product_name"
                outlined
                label="Product Name *"
                prepend-inner-icon="mdi-buffet"
                hide-details="auto"
                :error-messages="errors.product_name"
              />
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.pre_tax_irr"
                outlined
                label="Pre Tax IRR"
                prepend-inner-icon="mdi-buffet"
                hide-details="auto"
                :error-messages="errors.pre_tax_irr"
              />
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.minimum_invest"
                outlined
                label="Minimum Investment *"
                prepend-inner-icon="mdi-buffet"
                hide-details="auto"
                :error-messages="errors.minimum_invest"
              />
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.maximum_invest"
                outlined
                label="Maximum Investment *"
                prepend-inner-icon="mdi-buffet"
                hide-details="auto"
                :error-messages="errors.maximum_invest"
              />
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.end_tenure"
                outlined
                type="number"
                min="1"
                label="End Tenure (Months) *"
                prepend-inner-icon="mdi-buffet"
                hide-details="auto"
                :error-messages="errors.end_tenure"
              />
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref=""
                outlined
                v-model="form.risk_category"
                :items="riskCategoryItems"
                label="Risk Category"
                prepend-inner-icon="mdi-account-tie-outline"
                hide-details="auto"
                clearable
                :error-messages="errors.risk_category"
              />
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.amount_raised"
                outlined
                label="Amount Raised"
                prepend-inner-icon="mdi-buffet"
                hide-details="auto"
                :error-messages="errors.amount_raised"
              />
            </v-col>
            <v-col sm="4">
              <div class="text-caption grey--text text--darken-1 mb-1">
                Settlement / Payout Frequency
              </div>
              <v-btn-toggle
                v-model="form.payout_frequency"
                mandatory
                dense
                color="primary"
                class="d-flex"
              >
                <v-btn value="monthly" class="flex-grow-1" outlined>
                  <v-icon left small>mdi-calendar-month-outline</v-icon>
                  Monthly
                </v-btn>
                <v-btn value="yearly" class="flex-grow-1" outlined>
                  <v-icon left small>mdi-calendar-outline</v-icon>
                  Yearly
                </v-btn>
              </v-btn-toggle>
              <div v-if="errors.payout_frequency" class="v-messages error--text mt-1">
                {{ errors.payout_frequency }}
              </div>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.settlememt_date"
                    label="Settlement Date *"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    :error-messages="errors.settlememt_date"
                  />
                </template>
                <v-date-picker
                  v-model="form.settlememt_date"
                  @input="menu = false"
                />
              </v-menu>
            </v-col>
            <v-col sm="12" class="mb-2">
              <div class="text-subtitle-2 mb-2 font-weight-medium">Cover Photos</div>
              <input type="file" ref="imagesInput" multiple accept="image/*" @change="onImagesChange" style="display:none" />
              <v-btn outlined color="primary" small @click="$refs.imagesInput.click()">
                <v-icon left small>mdi-image-plus</v-icon> Add Photos
              </v-btn>
              <div v-if="previewImages.length" class="d-flex flex-wrap mt-3" style="gap:8px">
                <div v-for="(img, i) in previewImages" :key="i" style="position:relative">
                  <img :src="img" style="width:100px;height:80px;object-fit:cover;border-radius:8px;border:1px solid #ddd" />
                  <v-btn icon x-small color="error" style="position:absolute;top:-8px;right:-8px" @click="removePreviewImage(i)">
                    <v-icon x-small>mdi-close-circle</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-col sm="12" class="mb-2">
              <div class="text-subtitle-2 mb-2 font-weight-medium">Documents</div>
              <input type="file" ref="docsInput" multiple @change="onDocsChange" style="display:none" />
              <v-btn outlined color="secondary" small @click="$refs.docsInput.click()">
                <v-icon left small>mdi-file-plus</v-icon> Add Documents
              </v-btn>
              <v-list dense v-if="docFiles.length" class="mt-2 pa-0">
                <v-list-item v-for="(doc, i) in docFiles" :key="i" class="px-0">
                  <v-list-item-icon class="mr-2"><v-icon small color="primary">mdi-file-document</v-icon></v-list-item-icon>
                  <v-list-item-content><v-list-item-title class="text-body-2">{{ doc.name }}</v-list-item-title></v-list-item-content>
                  <v-list-item-action><v-btn icon x-small color="error" @click="removeDoc(i)"><v-icon x-small>mdi-close</v-icon></v-btn></v-list-item-action>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col sm="12">
              <v-textarea
                outlined
                v-model="form.description"
                label="Product Description"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save Product
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProductCreatePage",
  data() {
    return {
      form: {
        product_type_id: "",
        product_name: "",
        description: "",
        end_tenure: "",
        pre_tax_irr: "",
        minimum_invest: "",
        maximum_invest: "",
        amount_raised: "",
        settlememt_date: "",
        risk_category: "",
        payout_frequency: "monthly",
        category_ids: [],
      },
      errors: {},
      isLoading: false,
      menu: false,
      productTypeItems: [],
      categoryItems: [],
      riskCategoryItems: [
        { id: 1, text: "Low", value: 1 },
        { id: 2, text: "Medium", value: 2 },
        { id: 3, text: "High", value: 3 },
      ],
      imageFiles: [],
      previewImages: [],
      docFiles: [],
    };
  },
  mounted() {
    this.getMasters();
  },
  watch: {
    "form.end_tenure"(newVal) {
      if (newVal && !isNaN(newVal) && newVal > 0) {
        // Calculate settlement date from end tenure (in months)
        const today = new Date();
        const settlementDate = new Date(today);
        settlementDate.setMonth(settlementDate.getMonth() + parseInt(newVal));

        // Format as YYYY-MM-DD for v-date-picker
        const formattedDate = settlementDate.toISOString().split("T")[0];

        // Only update if different to avoid loops
        if (this.form.settlememt_date !== formattedDate) {
          this.form.settlememt_date = formattedDate;
        }
      }
    },
    "form.settlememt_date"(newVal) {
      if (newVal) {
        // Calculate end tenure from settlement date
        const today = new Date();
        const settlement = new Date(newVal);

        // Calculate difference in months
        const monthsDiff = Math.round(
          (settlement.getFullYear() - today.getFullYear()) * 12 +
            (settlement.getMonth() - today.getMonth()) +
            (settlement.getDate() - today.getDate()) / 30
        );

        // Only update if different and positive to avoid loops
        if (monthsDiff > 0 && this.form.end_tenure !== monthsDiff.toString()) {
          this.form.end_tenure = monthsDiff.toString();
        }
      }
    },
  },
  methods: {
    async getMasters() {
      try {
        const { data } = await axios.get("masters?context=product_type");

        this.productTypeItems = data.product_type.map((type) => ({
          id: type.id,
          text: type.name,
          value: type.id,
        }));
        const categoriesResponse = await axios.get("masters?context=category");
        this.categoryItems = categoriesResponse.data.category.map(
          (category) => ({
            text: category.name,
            value: category.id,
          })
        );
      } catch (error) {
        console.error(error);
      }
    },

    onImagesChange(e) {
      const files = Array.from(e.target.files);
      files.forEach(file => {
        this.imageFiles.push(file);
        this.previewImages.push(URL.createObjectURL(file));
      });
      this.$refs.imagesInput.value = null;
    },

    removePreviewImage(index) {
      this.imageFiles.splice(index, 1);
      this.previewImages.splice(index, 1);
    },

    onDocsChange(e) {
      Array.from(e.target.files).forEach(f => this.docFiles.push(f));
      this.$refs.docsInput.value = null;
    },

    removeDoc(index) {
      this.docFiles.splice(index, 1);
    },
    async save() {
      try {
        this.isLoading = true;
        const response = await axios.post("/products", this.form);

        const savedProduct = response.data.data;
        await this.handlefileuploads(savedProduct.id);

        this.$router.push("/products");
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },

    async handlefileuploads(productId) {
      if (this.imageFiles.length > 0) {
        const formData = new FormData();
        formData.append("id", productId);
        this.imageFiles.forEach(file => formData.append("images[]", file));

        try {
          await axios.post("products/upload_images", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
        } catch (error) {
          console.error("Image upload failed:", error);
        }
      }
      if (this.docFiles.length > 0) {
        const formData = new FormData();
        formData.append("id", productId);
        this.docFiles.forEach(f => formData.append("documents[]", f));
        try {
          await axios.post("products/upload_documents", formData, { headers: { "Content-Type": "multipart/form-data" } });
        } catch (error) {
          console.error("Document upload failed:", error);
        }
      }
    },
  },
};
</script>
